/* eslint-disable */
export default {
  _TitleLogo: 'TitleLogo',
  _Go: 'Go',
}